import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["cardElement", "errors", "saveButton", "successMessage"]

  connect() {
    this.stripe = Stripe(document.querySelector("meta[name='stripe-key']").content, { locale: 'en-GB' })
    this.elements = this.stripe.elements()
    this.card = this.elements.create('card', { style: { base: { fontSize: '16px', color: '#32325d' } } })
    if (this.hasCardElementTarget) {
      this.card.mount(this.cardElementTarget)
    }
  }

  save(event) {
    event.preventDefault()
    if (this.hasSaveButtonTarget) { this.saveButtonTarget.disabled = true }

    this.stripe.confirmCardSetup(this.data.get("clientSecret"), {
      payment_method: { card: this.card }
    }).then((result) => {
      if (result.error) {
        this.errorsTarget.textContent = result.error.message
        this.errorsTarget.classList.remove('d-none')
        if (this.hasSaveButtonTarget) { this.saveButtonTarget.disabled = false }
      } else {
        const paymentMethodId = result.setupIntent.payment_method
        fetch(this.data.get("savePaymentMethodUrl"), {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ payment_method_id: paymentMethodId })
        }).then((response) => {
          if (this.hasSaveButtonTarget) { this.saveButtonTarget.disabled = false }
          if (response.ok) {
            this.errorsTarget.classList.add('d-none')
            this.successMessageTarget.classList.remove('d-none')
          } else {
            this.errorsTarget.textContent = 'Could not save your card — please try again.'
            this.errorsTarget.classList.remove('d-none')
          }
        })
      }
    })
  }
}
